export default __webpack_public_path__ + "static/media/lapin-two-shapes-pdf.8830f30f.png";